goog.provide("shadow.js.shim.module$src$svg$arrows$arrow_bounce_right_svg$default");
shadow.js.shim.module$src$svg$arrows$arrow_bounce_right_svg$default = shadow.js.shim.module$src$svg$arrows$arrow_bounce_right_svg.default;
